import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CustomFormsModule} from 'ng2-validation';
import {HttpModule} from '@angular/http';
import {routing} from './components/app.routes';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { DecimalPipe } from '@angular/common';

import {KeysPipe} from './pipes/iterables.pipe';

import { NouisliderModule } from 'ng2-nouislider';

import {EmissionService} from './services/emission.service';
import {EmailService} from './services/email.service';
import {SpinnerService} from './services/spinner.service';
import {DashboardService} from './services/dashboard.service';
import {NavbarService} from './services/connectors/navbar.service';
import {FooterNavbarService} from './services/connectors/footer-navbar.service';

import {ErrorService} from './services/error.service';
import {NetworkService} from './services/network.service';
import {SalesForceService} from './services/salesforce.service';
import {VehicleService} from './services/calculator-items/vehicle.service';
import {IndividualTravelService} from './services/calculator-items/individual-travel.service';
import {BusinessFleetService} from './services/calculator-items/business-fleet.service';
import {EventsTravelService} from './services/calculator-items/events-travel.service';

import {AppComponent} from './components/app.component';
import {HomeComponent} from './components/home/home.component';
import {LimitComponent} from './components/limit/limit.component';
import {SpinnerComponent} from './components/spinner/spinner.component';
import {RangeComponent} from './components/range/range.component';
import {CalculatorComponent} from './components/calculator/calculator.component';
import {DashboardComponent} from './components/calculator/dashboard/dashboard.component';
import {CalculatorItemComponent} from './components/calculator/calculator-item/calculator-item.component';
// calculators components
import {IndividualCalculatorComponent} from './components/calculator/calculator-item/individual-calculator/individual-calculator.component';
import {BusinessCalculatorComponent} from './components/calculator/calculator-item/business-calculator/business-calculator.component';
import {EventsCalculatorComponent} from './components/calculator/calculator-item/events-calculator/events-calculator.component';
// shared calculators sub components-regions
import {HeaderComponent} from './components/calculator/calculator-item/shared/header/header.component';
import {FooterComponent} from './components/calculator/calculator-item/shared/footer/footer.component';
import {MethodologyComponent} from './components/calculator/calculator-item/shared/methodology/methodology.component';
import {NavbarComponent} from './components/calculator/calculator-item/shared/navbar/navbar.component';
// shared calculators sub components
import {EnergyComponent} from './components/calculator/calculator-item/shared/main/energy/energy.component';
import {VehicleComponent} from './components/calculator/calculator-item/shared/main/vehicle/vehicle.component';
// individual calculator sub components
import {IndividualTravelComponent} from './components/calculator/calculator-item/individual-calculator/individual-travel/individual-travel.component';
import {TransitComponent} from './components/calculator/calculator-item/individual-calculator/transit/transit.component';
// business calculator sub components
import {SiteComponent} from './components/calculator/calculator-item/business-calculator/site/site.component';
import {CommuteComponent} from './components/calculator/calculator-item/business-calculator/commute/commute.component';
import {ShippingComponent} from './components/calculator/calculator-item/business-calculator/shipping/shipping.component';
import {ServerComponent} from './components/calculator/calculator-item/business-calculator/server/server.component';
import {FleetListComponent} from './components/calculator/calculator-item/business-calculator/fleet/fleet-list/fleet-list.component';
// events calculator sub components
import {EventsGateComponent} from './components/calculator/calculator-item/events-calculator/events-gate/events-gate.component';
import {EventsTravelComponent} from './components/calculator/calculator-item/events-calculator/events-travel/events-travel.component';
import {EventsCommuteComponent} from 'components/calculator/calculator-item/events-calculator/commute/commute.component';
import {EventsTravelDefaultComponent} from './components/calculator/calculator-item/events-calculator/events-travel/events-travel-default/events-travel-default.component';
import {EventsLengthComponent} from './components/calculator/calculator-item/events-calculator/events-travel/events-length/events-length.component';
import {HotelComponent} from './components/calculator/calculator-item/events-calculator/events-travel/hotel/hotel.component';
import {EventsAverageComponent} from './components/calculator/calculator-item/events-calculator/events-travel/events-average/events-average.component';
import {VenueComponent} from './components/calculator/calculator-item/events-calculator/venue/venue.component';
import {WaterComponent} from './components/calculator/calculator-item/events-calculator/water/water.component';
import {MealsComponent} from './components/calculator/calculator-item/events-calculator/meals/meals.component';
// shared vehicle component sub components
import {VehicleDefaultComponent} from './components/calculator/calculator-item/shared/main/vehicle/vehicle-default/vehicle-default.component';
import {CarComponent} from './components/calculator/calculator-item/shared/main/vehicle/car/car.component';
import {EcarComponent} from './components/calculator/calculator-item/shared/main/vehicle/ecar/ecar.component';
import {MotorcycleComponent} from './components/calculator/calculator-item/shared/main/vehicle/motorcycle/motorcycle.component';
import {BoatComponent} from './components/calculator/calculator-item/shared/main/vehicle/boat/boat.component';
import {OptionsComponent} from './components/calculator/calculator-item/shared/main/vehicle/car/options/options.component';
// import {ClassComponent} from './components/calculator/calculator-item/shared/main/vehicle/car/class/class.component';
import {VehicleListComponent} from './components/calculator/calculator-item/shared/main/vehicle/vehicle-list/vehicle-list.component';
// shared energy(home) component sub components
import { EnergyDefaultComponent } from './components/calculator/calculator-item/shared/main/energy/energy-default/energy-default.component';
import { EnergyAddComponent } from './components/calculator/calculator-item/shared/main/energy/energy-add/energy-add.component';
// shared thankyou component
import { ThankyouComponent } from './components/calculator/calculator-item/shared/main/thankyou/thankyou.component';
// travel component sub components
import {IndividualTravelDefaultComponent} from './components/calculator/calculator-item/individual-calculator/individual-travel/individual-travel-default/individual-travel-default.component';
import {IndividualFlightsComponent} from './components/calculator/calculator-item/individual-calculator/individual-travel/individual-flights/individual-flights.component';
import {IndividualMilesComponent} from './components/calculator/calculator-item/individual-calculator/individual-travel/individual-miles/individual-miles.component';
import {IndividualFuelComponent} from './components/calculator/calculator-item/individual-calculator/individual-travel/individual-fuel/individual-fuel.component';
import {IndividualLengthComponent} from './components/calculator/calculator-item/individual-calculator/individual-travel/individual-length/individual-length.component';
import {IndividualFlightsListComponent} from './components/calculator/calculator-item/individual-calculator/individual-travel/individual-flights-list/individual-flights-list.component';
import { BusinessGateComponent } from './components/calculator/calculator-item/business-calculator/business-gate/business-gate.component';
import { FleetComponent } from './components/calculator/calculator-item/business-calculator/fleet/fleet.component';
import { AirTravelComponent } from './components/calculator/calculator-item/business-calculator/air-travel/air-travel.component';
import { SiteDefaultComponent } from './components/calculator/calculator-item/business-calculator/site/site-default/site-default.component';
import { SiteAddComponent } from './components/calculator/calculator-item/business-calculator/site/site-add/site-add.component';
import { FleetDefaultComponent } from './components/calculator/calculator-item/business-calculator/fleet/fleet-default/fleet-default.component';
import { FleetCarComponent } from './components/calculator/calculator-item/business-calculator/fleet/fleet-car/fleet-car.component';
import { FleetEcarComponent } from './components/calculator/calculator-item/business-calculator/fleet/fleet-ecar/fleet-ecar.component';
import { FleetBoatComponent } from './components/calculator/calculator-item/business-calculator/fleet/fleet-boat/fleet-boat.component';
import { AirTravelDefaultComponent } from './components/calculator/calculator-item/business-calculator/air-travel/air-travel-default/air-travel-default.component';
import { AirTravelMilesComponent } from './components/calculator/calculator-item/business-calculator/air-travel/air-travel-miles/air-travel-miles.component';
import { AirTravelEmployeeComponent } from './components/calculator/calculator-item/business-calculator/air-travel/air-travel-employee/air-travel-employee.component';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        SpinnerComponent,
        RangeComponent,
        CalculatorComponent,
        DashboardComponent,
        CalculatorItemComponent,
        IndividualCalculatorComponent,
        BusinessCalculatorComponent,
        EventsCalculatorComponent,
        HeaderComponent,
        FooterComponent,
        MethodologyComponent,
        NavbarComponent,
        EnergyComponent,
        VehicleComponent,
        IndividualTravelComponent,
        TransitComponent,
        SiteComponent,
        CommuteComponent,
        ShippingComponent,
        ServerComponent,
        EventsGateComponent,
        EventsTravelComponent,
        EventsTravelDefaultComponent,
        EventsLengthComponent,
        EventsAverageComponent,
        HotelComponent,
        VenueComponent,
        WaterComponent,
        MealsComponent,
        VehicleDefaultComponent,
        CarComponent,
        EcarComponent,
        MotorcycleComponent,
        BoatComponent,
        OptionsComponent,
        // ClassComponent,
        VehicleListComponent,
        EnergyDefaultComponent,
        EnergyAddComponent,
        IndividualTravelDefaultComponent,
        IndividualFlightsComponent,
        IndividualMilesComponent,
        IndividualFuelComponent,
        IndividualLengthComponent,
        KeysPipe,
        IndividualFlightsListComponent,
        BusinessGateComponent,
        FleetComponent,
        AirTravelComponent,
        SiteDefaultComponent,
        SiteAddComponent,
        FleetDefaultComponent,
        FleetListComponent,
        FleetCarComponent,
        FleetEcarComponent,
        FleetBoatComponent,
        AirTravelDefaultComponent,
        AirTravelMilesComponent,
        AirTravelEmployeeComponent,
        EventsCommuteComponent,
        ThankyouComponent,
        LimitComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        NouisliderModule,
        ReactiveFormsModule,
        CustomFormsModule,
        HttpModule,
        routing,
        Ng2AutoCompleteModule
    ],
    providers: [
        NavbarService,
        SpinnerService,
        FooterNavbarService,
        NetworkService,
        SalesForceService,
        VehicleService,
        IndividualTravelService,
        BusinessFleetService,
        EventsTravelService,
        ErrorService,
        EmissionService,
        DashboardService,
        EmailService,
        DecimalPipe
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts